module.exports = __webpack_public_path__ + "static/media/Left_Arrow_New.2a8429fa.svg";